/**
 * ============================================================================
 * Auth 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义认证相关的所有枚举类型
 * - 包含：UserStatus（用户状态）
 * 
 * 📖 对应后端：
 * - Model: backend/app/Models/User.php (常量定义)
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * 🔄 更新时机：
 * - 后端新增枚举值时
 * - 后端修改枚举值时
 * - 业务新增状态/类型时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Models/User.php
 * 2. 找到所有 const STATUS_* 等常量定义
 * 3. 检查枚举值、名称是否与后端一致
 * 4. 检查是否有遗漏或多余的枚举值
 * 
 * @module types/auth/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

/**
 * ⚠️ UserStatus 已移至 types/user/enums.ts
 * 
 * 请使用：
 * ```typescript
 * import { UserStatus } from '../user'
 * ```
 * 
 * @deprecated 请从 @bayes-mes/shared/types/user 导入
 */
// UserStatus 已移至 types/user/enums.ts，请从那里导入

/**
 * 设备类型枚举
 */
export enum DeviceType {
  /** Web浏览器 */
  WEB = 'web',
  /** iOS应用 */
  IOS = 'ios',
  /** Android应用 */
  ANDROID = 'android',
  /** 小程序 */
  MINI_PROGRAM = 'mini_program',
  /** 其他 */
  OTHER = 'other',
}

